import { Component, EventEmitter, Output, Input, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoginService } from '../../../shared-modules/login/login.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'general-confirmation',
    templateUrl: './general-confirmation.component.html'
})
export class GeneralConfirmationComponent implements OnInit {

    @Input() headerLabel: string;
    @Input() confirmMessage: string;
    @Input() disableConfirmation: boolean;
    @Input() okButtonLabel: string;
    @Input() okButtonImage = 'save.png';
    @Input() okButtonDisabledImage = 'savedisablednocircle.png';
    @Input() backButtonLabel = 'Back';
    @Input() showProceed: boolean;
    @Input() informational = false;
    @Input() secondMessage: string;
    @Input() warning: boolean;
    @Input() headerCenterAlign = false;
    @Input() okTylerAstId = 'GenericDialogASTOk';
    @Input() closeTylerAstId = 'GenericDialogASTClose';
    @Output() confirmEvent = new EventEmitter();
    @Output() previousEvent = new EventEmitter();
    @Input() showSteps: string;
    @Input() checkBoxAcceptance = false;
    @Input() acceptanceMessage: string;
    @Input() secondMessageWarning = false;
    @Input() footerMessage: string;
    @Input() showBackBtn = false;

    cancelButtonLabel = 'Cancel';
    isAccepted = false;
    isOkButtonDisabled = false;
    isDynamicCancelLable = '' ;


    constructor(
        private dialog: MatDialogRef<GeneralConfirmationComponent>,
        @Inject(MAT_DIALOG_DATA) private data: any
    ) {
        if (this.okButtonLabel == undefined || this.okButtonLabel == '') {
            this.okButtonLabel = 'OK';
        }
    }

    ngOnInit(): void {
        // Setting injected data
        if (this.data) {
            if (this.data.headerLabel) {
                this.headerLabel = this.data.headerLabel;
            }
            if (this.data.confirmMessage) {
                this.confirmMessage = this.data.confirmMessage;
            }
            if (this.data.disableConfirmation) {
                this.disableConfirmation = this.data.disableConfirmation;
            }
            if (this.data.okButtonLabel) {
                this.okButtonLabel = this.data.okButtonLabel;
            }
            if (this.data.showProceed) {
                this.showProceed = this.data.showProceed;
            }
            if (this.data.informational) {
                this.informational = this.data.informational;
            }
            if (this.data.secondMessage) {
                this.secondMessage = this.data.secondMessage;
            }
            if (this.data.warning) {
                this.warning = this.data.warning;
            }
            if (this.data.showSteps) {
                this.showSteps = this.data.showSteps;
            }
            if (this.data.checkBoxAcceptance) {
                this.checkBoxAcceptance = this.data.checkBoxAcceptance;
            }
            if (this.data.acceptanceMessage) {
                this.acceptanceMessage = this.data.acceptanceMessage;
            }
            if (this.data.okButtonDisabledImage) {
                this.okButtonDisabledImage = this.data.okButtonDisabledImage;
            }
            if (this.data.secondMessageWarning) {
                this.secondMessageWarning = this.data.secondMessageWarning;
            }
            if (this.data.okButtonImage) {
                this.okButtonImage = this.data.okButtonImage;
            }
            if (this.data.headerCenterAlign) {
                this.headerCenterAlign = this.data.headerCenterAlign;
            }
        }

        // If acceptance is enabled then make sure ok button must be disabled untill acceptance checkbox is checked.
        this.checkForAcceptance();
    }

    okClick() {
        this.confirmEvent.emit(true);
        this.dialog.close(true);
    }
    backClick() {
        this.previousEvent.emit(true);
        this.dialog.close(true);
    }

    cancelClick() {
        this.dialog.close(false);
    }

    onAcceptanceClick() {
        this.checkForAcceptance();
    }

    checkForAcceptance() {
        if (this.checkBoxAcceptance && !this.isAccepted) {
            this.isOkButtonDisabled = true;
        }
        else {
            this.isOkButtonDisabled = false;
        }
    }
}
